import React from 'react'
import { useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'

import {
  SuperEndWetSchema,
  initialSuperEndWetValues,
} from '../../utils/validation/superEndWet.js'
import { useSideNav } from '../../contexts/SideNavOpenContext.js'
import { useRecordLock } from '../../contexts/RecordLockContext'
import useSuperEnd from '../../hooks/useSuperEnd'

import ActionBar from '../shared/ActionBar.js'

import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

import { DatePicker } from '@mui/x-date-pickers/DatePicker'

const SuperMidWet = () => {
  const { id } = useParams()
  const { sideNavOpen } = useSideNav(true)
  const { recordLock, setRecordLock } = useRecordLock()
  const { getSuperEndDraft, patchSuperEndWetDraft } = useSuperEnd({ id })

  const handleSave = (values, { setSubmitting }) => {
    patchSuperEndWetDraft.mutate(values)
    setSubmitting(false)
    setRecordLock(true)
  }

  const handleChange = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    setValues({ ...values, [name]: value })
  }

  const handleDateChange = (name, value, values, setValues) => {
    setValues({ ...values, [name]: value })
  }
  return (
    <>
      <Formik
        initialValues={{
          ...initialSuperEndWetValues,
          ...getSuperEndDraft?.data,
        }}
        validationSchema={SuperEndWetSchema}
        onSubmit={(values, { setSubmitting }) =>
          handleSave(values, { setSubmitting })
        }
        enableReinitialize
      >
        {({
          isSubmitting,
          handleSubmit,
          values,
          touched,
          errors,
          setValues,
        }) => (
          <>
            <Form id={`SuperEndWet${id}`} onSubmit={handleSubmit}>
              <Grid
                container
                justifyContent='center'
                alignItems='center'
                sx={{
                  pl: sideNavOpen ? '260px' : '60px',
                  pt: '70px',
                  pr: '10px',
                  pb: '100px',
                }}
              >
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <Typography variant='h1'>
                    Supervisor End Shift Passdown Wet Side
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Name
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetName'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetName}
                    error={touched.wetName && !!errors.wetName}
                    helperText={touched.wetName && errors.wetName}
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <span style={{ color: 'red' }}>
                    * Note: Wet and Dry Start Date and Shift must match in order
                    for email to be sent
                  </span>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Date Shift Started
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DatePicker
                    name='wetDate'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange('wetDate', value, values, setValues)
                    }
                    value={values.wetDate}
                    error={touched.wetDate && !!errors.wetDate}
                    helperText={touched.wetDate && errors.wetDate}
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='wetShift'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetShift}
                    error={touched.wetShift && !!errors.wetShift}
                    helperText={touched.wetShift && errors.wetShift}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='A Day'>A Day</MenuItem>
                    <MenuItem value='A Night'>A Night</MenuItem>
                    <MenuItem value='B Day'>B Day</MenuItem>
                    <MenuItem value='B Night'>B Night</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Message From Sender
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetMessage'
                    multiline
                    maxRows={Infinity}
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetMessage}
                    error={touched.wetMessage && !!errors.wetMessage}
                    helperText={touched.wetMessage && errors.wetMessage}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    PASSDOWN
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Alarm Notice or Shutdown
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetAlarmNotice'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetAlarmNotice}
                    error={touched.wetAlarmNotice && !!errors.wetAlarmNotice}
                    helperText={touched.wetAlarmNotice && errors.wetAlarmNotice}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    # Broken State Seals
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetBrokenStateSeals'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetBrokenStateSeals}
                    error={
                      touched.wetBrokenStateSeals &&
                      !!errors.wetBrokenStateSeals
                    }
                    helperText={
                      touched.wetBrokenStateSeals && errors.wetBrokenStateSeals
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    INTAKE
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='intakeComments'
                    multiline
                    maxRows={Infinity}
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.intakeComments}
                    error={touched.intakeComments && !!errors.intakeComments}
                    helperText={touched.intakeComments && errors.intakeComments}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Cream Load Outs
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='creamLoadOuts'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.creamLoadOuts}
                    error={touched.creamLoadOuts && !!errors.creamLoadOuts}
                    helperText={touched.creamLoadOuts && errors.creamLoadOuts}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Downtime (Hrs)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='intakeDowntime'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.intakeDowntime}
                    error={touched.intakeDowntime && !!errors.intakeDowntime}
                    helperText={touched.intakeDowntime && errors.intakeDowntime}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Downtime Reasons
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='intakeDowntimeReasons'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.intakeDowntimeReasons}
                    error={
                      touched.intakeDowntimeReasons &&
                      !!errors.intakeDowntimeReasons
                    }
                    helperText={
                      touched.intakeDowntimeReasons &&
                      errors.intakeDowntimeReasons
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    WET PROCESSING
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wpComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wpComments}
                    error={touched.wpComments && !!errors.wpComments}
                    helperText={touched.wpComments && errors.wpComments}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    CIP Comments/Issues
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wpCipComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wpCipComments}
                    error={touched.wpCipComments && !!errors.wpCipComments}
                    helperText={touched.wpCipComments && errors.wpCipComments}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    HTST Regulatory Issues (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='wpHistRegulatoryIssues'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wpHistRegulatoryIssues}
                    error={
                      touched.wpHistRegulatoryIssues &&
                      !!errors.wpHistRegulatoryIssues
                    }
                    helperText={
                      touched.wpHistRegulatoryIssues &&
                      errors.wpHistRegulatoryIssues
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Y'>Y</MenuItem>
                    <MenuItem value='N'>N</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Sep 1 Dislodge Verified (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='sep1Dislodge'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.sep1Dislodge}
                    error={touched.sep1Dislodge && !!errors.sep1Dislodge}
                    helperText={touched.sep1Dislodge && errors.sep1Dislodge}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Y'>Y</MenuItem>
                    <MenuItem value='N'>N</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Sep 2 Dislodge Verified (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='sep2Dislodge'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.sep2Dislodge}
                    error={touched.sep2Dislodge && !!errors.sep2Dislodge}
                    helperText={touched.sep2Dislodge && errors.sep2Dislodge}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Y'>Y</MenuItem>
                    <MenuItem value='N'>N</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Sep 3 Dislodge Verified (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='sep3Dislodge'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.sep3Dislodge}
                    error={touched.sep3Dislodge && !!errors.sep3Dislodge}
                    helperText={touched.sep3Dislodge && errors.sep3Dislodge}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Y'>Y</MenuItem>
                    <MenuItem value='N'>N</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Dislodge Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='sepDislodgeComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.sepDislodgeComments}
                    error={
                      touched.sepDislodgeComments &&
                      !!errors.sepDislodgeComments
                    }
                    helperText={
                      touched.sepDislodgeComments && errors.sepDislodgeComments
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    UF Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='ufComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.ufComments}
                    error={touched.ufComments && !!errors.ufComments}
                    helperText={touched.ufComments && errors.ufComments}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    NF Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='nfComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.nfComments}
                    error={touched.nfComments && !!errors.nfComments}
                    helperText={touched.nfComments && errors.nfComments}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Permeate Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='permeateComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.permeateComments}
                    error={
                      touched.permeateComments && !!errors.permeateComments
                    }
                    helperText={
                      touched.permeateComments && errors.permeateComments
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    BUTTER
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Butter Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterComments}
                    error={touched.butterComments && !!errors.butterComments}
                    helperText={touched.butterComments && errors.butterComments}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Pallets Produced (# Pallets - Product)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterPalletsProduced'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterPalletsProduced}
                    error={
                      touched.butterPalletsProduced &&
                      !!errors.butterPalletsProduced
                    }
                    helperText={
                      touched.butterPalletsProduced &&
                      errors.butterPalletsProduced
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Butter Remelted Pallet IDs
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterRemeltedPalletIds'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterRemeltedPalletIds}
                    error={
                      touched.butterRemeltedPalletIds &&
                      !!errors.butterRemeltedPalletIds
                    }
                    helperText={
                      touched.butterRemeltedPalletIds &&
                      errors.butterRemeltedPalletIds
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Fat Churn 1
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='avgFatChurn1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.avgFatChurn1}
                    error={touched.avgFatChurn1 && !!errors.avgFatChurn1}
                    helperText={touched.avgFatChurn1 && errors.avgFatChurn1}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Fat Churn 2
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='avgFatChurn2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.avgFatChurn2}
                    error={touched.avgFatChurn2 && !!errors.avgFatChurn2}
                    helperText={touched.avgFatChurn2 && errors.avgFatChurn2}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Employee Butter (#Cases)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='employeeButterCases'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.employeeButterCases}
                    error={
                      touched.employeeButterCases &&
                      !!errors.employeeButterCases
                    }
                    helperText={
                      touched.employeeButterCases && errors.employeeButterCases
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    GMP COMPLIANCE
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    # GMP Violations
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetGmpViolations'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetGmpViolations}
                    error={
                      touched.wetGmpViolations && !!errors.wetGmpViolations
                    }
                    helperText={
                      touched.wetGmpViolations && errors.wetGmpViolations
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetGmpViolationComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetGmpViolationComments}
                    error={
                      touched.wetGmpViolationComments &&
                      !!errors.wetGmpViolationComments
                    }
                    helperText={
                      touched.wetGmpViolationComments &&
                      errors.wetGmpViolationComments
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    AUDIT TASKS
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Audit Date
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetAuditDate'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetAuditDate}
                    error={touched.wetAuditDate && !!errors.wetAuditDate}
                    helperText={touched.wetAuditDate && errors.wetAuditDate}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Audit Tasks Completed (By ID)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetAuditTasksCompleted'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetAuditTasksCompleted}
                    error={
                      touched.wetAuditTasksCompleted &&
                      !!errors.wetAuditTasksCompleted
                    }
                    helperText={
                      touched.wetAuditTasksCompleted &&
                      errors.wetAuditTasksCompleted
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    USDA Audit Tasks Completed (By ID)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetUsdaAuditTasksCompleted'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetUsdaAuditTasksCompleted}
                    error={
                      touched.wetUsdaAuditTasksCompleted &&
                      !!errors.wetUsdaAuditTasksCompleted
                    }
                    helperText={
                      touched.wetUsdaAuditTasksCompleted &&
                      errors.wetUsdaAuditTasksCompleted
                    }
                  />
                </Grid>
              </Grid>
              <ActionBar
                id={id}
                editOnly={true}
                values={values}
                setValues={setValues}
                record='superendwet'
                newToolTip='New Super End Wet Passdown'
              />
            </Form>
          </>
        )}
      </Formik>
    </>
  )
}

export default SuperMidWet
